<div class="changelog-container">
  <div class="changelog-card">
    <h1 class="changelog-title">Changelog</h1>
    <p class="changelog-subtitle">Alle Änderungen und neue Funktionen im Überblick.</p>
    <div class="changelog-content" [innerHTML]="changelogHtml"></div>
  </div>
</div>

<app-bottom-bar></app-bottom-bar>
